import React from "react";

export const ArrowDown = ({ color = "#51569F" }) => {
  return (
    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_122_27488)">
        <path
          d="M12.6083 10.9885C11.8304 12.2685 9.97219 12.2685 9.19166 10.9885L4.74337 3.69372C3.93064 2.36093 4.8883 0.653714 6.44864 0.653715L15.3306 0.653715C16.8909 0.653716 17.852 2.36093 17.0419 3.69372L12.6083 10.9885Z"
          fill={color}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_122_27488"
          x="0.447754"
          y="0.653687"
          width="20.8882"
          height="19.2948"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_122_27488" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_122_27488" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};
